import { Ether } from 'types'
import { isZero } from './number'
import { MINIMUM_ORDER_VALUE } from 'constants/trade'

/**
 * Checks if the order value is valid based on the provided parameters.
 * @param baseCurrencyAmount - The amount of the base currency.
 * @param price - The price of the order.
 * @param baseMinimumQuantity - The minimum quantity of the base currency.
 * @returns A boolean indicating whether the order value is valid or not.
 */
export function checkOrderValue(
  baseCurrencyAmount: Ether,
  price: Ether,
  baseMinimumQuantity: number,
): [boolean, string] {
  if (isZero(price)) {
    return [false, 'Enter a price']
  }
  if (isZero(baseCurrencyAmount)) {
    return [false, 'Enter a amount']
  }

  if (Number(baseCurrencyAmount) < baseMinimumQuantity) {
    return [false, `The order amount minimum of ${baseMinimumQuantity}`]
  }

  if (Number(baseCurrencyAmount) * Number(price) < MINIMUM_ORDER_VALUE) {
    return [false, `The order value minimum of ${MINIMUM_ORDER_VALUE} USDT`]
  }
  return [true, '']
}
